module.exports = __webpack_public_path__ + "img/notecase1.e82ab306.png";